export default {
  title: "Agregador"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5006: { text: "Ocurrió un error en el catálogo de Agregador" }
    , WS5006: { text: "Ocurrió un error en el catálogo de Agregador" }
    , JS5006: { text: "Ocurrió un error en el catálogo de Agregador" }
    , CR5006: { text: "Ocurrió un error en el catálogo de Agregador" }
    , UK_Agregador: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/agregador.js